export default class RoleModel {
    RoleId: number;
    RoleName: string;
    Description: string; 
}
